// constants
export type LanguageName = "en" | "nl" | "de" | "fr" | "es";

// actions
export const LANGUAGE_SET_LOCALE = "language_set_locale";


interface LanguageState {
  locale: LanguageName
}

const initialState: LanguageState = {
  locale: "nl"
};

export const setLocale = (locale: LanguageName) => async (dispatch: any) => {
  dispatch({
    type: LANGUAGE_SET_LOCALE,
    payload: {
      locale: locale
    }
  });
}

export default function (state = initialState, action: any) {
  switch (action.type) {
    case LANGUAGE_SET_LOCALE: {
      return {
        ...state,
        locale: action.payload.locale
      };
    }
    default:
      return state;
  }
}
